var TOKEN_NAMES = {
    PROGRAM: 'program',
    PROCEDURE: 'procedure',
    FUNCTION: 'function',
    RETURN: 'return',
    DROP: 'Poner',
    MOVE: 'Mover',
    GRAB: 'Sacar',
    BOOM: 'BOOM',
    MOVE_TO_EDGE: 'IrAlBorde',
    CLEAN_BOARD: 'VaciarTablero',
    REPEAT: 'repeat',
    WHILE: 'while',
    FOR_EACH: 'foreach',
    IN: 'in',
    IF: 'if',
    THEN: 'then',
    ELSE: 'else',
    SWITCH: 'switch',
    TO: 'to',
    OPPOSITE: 'opuesto',
    NEXT: 'siguiente',
    PREVIOUS: 'previo',
    DIV: 'div',
    MOD: 'mod',
    NOT: 'not',
    HAS_STONES: 'hayBolitas',
    CAN_MOVE: 'puedeMover',
    NUM_STONES: 'nroBolitas',
    MIN_DIR: 'minDir',
    MAX_DIR: 'maxDir',
    MIN_COLOR: 'minColor',
    MAX_COLOR: 'maxColor',
    MIN_BOOL: 'minBool',
    MAX_BOOL: 'maxBool',
    RED: 'Rojo',
    BLUE: 'Azul',
    BLACK: 'Negro',
    GREEN: 'Verde',
    TRUE: 'True',
    FALSE: 'False',
    NORTH: 'Norte',
    SOUTH: 'Sur',
    EAST: 'Este',
    WEST: 'Oeste',
    BOOLEAN: 'Booleano',
    COLOR: 'Color',
    DIRECTION: 'Dirección',
    NUMBER: 'Número'
};

module.exports = TOKEN_NAMES;



//////////////////
// WEBPACK FOOTER
// ./lib/grammar/reserved-words.js
// module id = 4
// module chunks = 0